
import { Routes, Route } from "react-router-dom";
import React from 'react';
import { AppContextProvider } from "./context/AppContext";
import { LandingPage } from "./pages/LandingPage";
import { SignIn } from "./pages/SignIn";
import { SignUp } from "./pages/SignUp";

function App() {

    return (
        <AppContextProvider>
            <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/signin" element={<SignIn />} />
                <Route path="/signup" element={<SignUp />} />
                <Route path="*" element={<NoFound />} />
            </Routes>
        </AppContextProvider>
    );

}


export default App;

function NoFound() {
    return (
        <div>
            <h2>404 Not Found</h2>
        </div>
    );
}

